import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../store/authStore';
import { Home, FileText, Plus, UserCheck, User } from 'lucide-react';
export default function MobileNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const isAgentOrAdmin = user && ['admin', 'agent'].includes(user.role);

  if (!user) return null;

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const items = [
    { to: '/', label: t('mobileNav.home'), icon: Home, show: true },
    { to: '/tickets', label: t('mobileNav.tickets'), icon: FileText, show: true },
    { to: '__create__', label: t('mobileNav.newTicket'), icon: Plus, show: true, fab: true },
    ...(isAgentOrAdmin ? [{ to: '/attendance', label: t('mobileNav.attendance'), icon: UserCheck, show: true }] : []),
    { to: '/profile', label: t('mobileNav.profile'), icon: User, show: true },
  ];

  const handleCreate = () => {
    navigate('/tickets?create=true');
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-surface-0 border-t border-surface-400/15 shadow-[0_-2px_10px_rgba(0,0,0,0.05)]"
      aria-label={t('mobileNav.home')}>
      <div className="flex items-center justify-around h-16 px-2">
        {items.filter(i => i.show).map((item) => {
          const Icon = item.icon;
          if (item.fab) {
            return (
              <button
                key="create"
                onClick={handleCreate}
                className="flex flex-col items-center justify-center -mt-5 w-14 h-14 rounded-full bg-primary-600 text-white shadow-elevated"
                aria-label={item.label}
              >
                <Icon size={24} />
              </button>
            );
          }
          const active = isActive(item.to);
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`flex flex-col items-center justify-center gap-0.5 flex-1 py-2 transition-colors ${
                active ? 'text-primary-600' : 'text-surface-400'
              }`}
              aria-label={item.label}
            >
              <Icon size={20} />
              <span className="text-[10px] leading-tight">{item.label}</span>
              {active && <div className="w-1 h-1 rounded-full bg-primary-600 mt-0.5" />}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
